import { WbTrapFocus } from './WbTrapFocus';
import { assign } from 'lodash';

class QuizController {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-open-quiz', _this.openQuiz.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-start-quiz', _this.start.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener(
        'change',
        '.wb-publication-quiz__options__input',
        _this.selectOption.bind(_this)
      );

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-continue-quiz', _this.goToNext.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-prev-quiz', _this.goToPrev.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-publication-quiz__close', _this.closeQuiz.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener(
        'change',
        '.wb-publication-quiz .frm-star-group input',
        _this.fixStarRating.bind(_this)
      );

    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('body').classList.contains('load-overlay');

    if (!overlayIsActive) {
      const icon = document.createElement('div');
      icon.classList.add('load-overlay__icon');

      document.querySelector('body').classList.add('load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.load-overlay').classList.remove('load-overlay');
      document.querySelector('.load-overlay__icon').remove();
    }
  }

  keydownEventListener(e) {
    const overlay = document.querySelector('#wb-publication-quiz');
    const isOpen = overlay?.classList.contains('wb-overlay--open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        this.closeQuiz();
        break;
    }
  }

  fixStarRating(e) {
    const target = e.targetElement;
    const index = [...target.parentElement.children].indexOf(target);

    document.querySelectorAll('.wb-publication-quiz .star-rating')?.forEach((label, i) => {
      const actualIndex = i * 2 + 1;
      if (actualIndex <= index) label.classList.add('star-rating--active');
      else label.classList.remove('star-rating--active');
    });
  }

  openQuiz(e) {
    const target = e.targetElement;
    const publication_id = target.getAttribute('data-publication-id');

    this.refTrigger = e.targetElement;
    this.fetchQuiz(publication_id).then(() => {
      const overlay = document.querySelector('.wb-overlay');

      this.WbTrapFocus = new WbTrapFocus({
        ele: overlay,
        activeClass: 'wb-overlay--open',
      });

      overlay.querySelector('.js-start-quiz').focus();
    });

    document.querySelector('html, body').classList.add('wb-overlay--active');
  }

  closeQuiz() {
    const overlay = document.querySelector('.wb-overlay');

    overlay._hide(0.5).then(() => overlay.remove());

    this.refTrigger.focus();
    this.refTrigger = false;
    this.reset();

    document.querySelector('html, body').classList.remove('wb-overlay--active');
  }

  fetchQuiz(id) {
    const _this = this;

    this.toggleAjaxOverlay();

    return new Promise((resolve, reject) => {
      fetch(ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: `action=get_publication_quiz&publication_id=${id}`,
      })
        .then((response) => {
          if (!response.ok) {
            this.toggleAjaxOverlay();
            reject(response.statusText);
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then((data) => {
          const PARSER = new DOMParser();
          const DOC = PARSER.parseFromString(data, 'text/html');
          const quiz = DOC.querySelector('.wb-publication-quiz');

          if (quiz) {
            document.querySelector('body').appendChild(quiz);
            quiz._show(0.5);
            quiz.classList.add('wb-overlay--open');
          }

          _this.toggleAjaxOverlay();
          resolve();
        })
        .catch((error) => console.error(error));
    });
  }

  fetchResult() {
    const _this = this;

    this.toggleAjaxOverlay();

    return new Promise((resolve, reject) => {
      fetch(`${window.location.origin}/wp-json/educaloi/quiz/save`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(_this.data),
      })
        .then((response) => {
          if (!response.ok) {
            this.toggleAjaxOverlay();
            reject(response.statusText);
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then((data) => {
          const RESPONSE = JSON.parse(data);

          _this.toggleAjaxOverlay();

          if (!RESPONSE.success) {
            reject(RESPONSE.data);
            throw Error(RESPONSE.data);
          }

          const PARSER = new DOMParser();
          const DOC = PARSER.parseFromString(RESPONSE.data, 'text/html');
          const result = DOC.querySelector('.wb-publication-quiz__inner--last');

          if (!result) {
            alert(RESPONSE.data);
            reject(RESPONSE.data);
            _this.closeQuiz();
            return;
          }

          document.querySelector('.wb-overlay__inner').appendChild(result);

          resolve();
        })
        .catch((error) => console.error(error));
    });
  }

  reset() {
    this.data = {};
    this.total = 0;
  }

  setInitialData() {
    const quiz_id = document.querySelector('.wb-publication-quiz').getAttribute('data-quiz-id');
    const totalQuestions = document.querySelectorAll(
      '.wb-publication-quiz__inner--question'
    ).length;

    this.data = {
      id: quiz_id,
      result: [],
      quiz: [],
    };
    this.total = totalQuestions;
  }

  start() {
    this.setInitialData();
    this.goToNext();
  }

  finish(currentIndex) {
    this.compileScore();
    this.fetchResult().then(() => {
      const result = document.querySelector('.wb-publication-quiz__inner--last');
      const currentQuestion = document.querySelector(`[data-question="${currentIndex}"]`);

      currentQuestion._hide(0);
      result._show(0);
      result.style.display = 'flex';
      result.scrollTop = 0;
    });
  }

  goToPrev(e) {
    let currentIndex = 0;

    if (e) currentIndex = parseInt(e.targetElement.getAttribute('data-index'));

    const currentQuestion = document.querySelector(`[data-question="${currentIndex}"]`);
    const prevQuestion = document.querySelector(`[data-question="${currentIndex - 1}"]`);

    currentQuestion._hide(0);
    prevQuestion._show(0);
    prevQuestion.style.display = 'flex';
    prevQuestion.scrollTop = 0;
  }

  goToNext(e) {
    let currentIndex = 0;

    if (e) currentIndex = parseInt(e.targetElement.getAttribute('data-index'));
    if (currentIndex == this.total) {
      this.addResult(currentIndex);
      this.finish(currentIndex);
      return;
    }

    if (currentIndex != 0) this.addResult(currentIndex);

    const currentQuestion = document.querySelector(`[data-question="${currentIndex}"]`);
    const nextQuestion = document.querySelector(`[data-question="${currentIndex + 1}"]`);

    currentQuestion._hide(0);
    nextQuestion._show(0);
    nextQuestion.style.display = 'flex';
    nextQuestion.scrollTop = 0;
  }

  addResult(currentIndex) {
    const selected = document.querySelector(`[name="quiz-option-${currentIndex}"]:checked`);
    const parent = selected.closest('[data-question]');

    const id = parent.getAttribute('data-id');
    const question = parent.querySelector('.wb-publication-quiz__header__question__name').innerText;
    const choice = selected.nextElementSibling.innerText;
    const values = [];

    for (const value in selected.dataset) {
      if (!/value-/.test(value)) continue;
      values.push(parseInt(selected.dataset[value]));
    }

    const result = {
      id,
      question,
      choice,
      values,
    };

    const questionExists = this.data.quiz.find((el) => {
      if (el.id === id) assign(el, result);
      return el.id === id;
    });

    if (!questionExists) this.data.quiz.push(result);
  }

  compileScore() {
    const { quiz } = this.data;

    quiz.forEach((el) => {
      this.data.result = this.sum(this.data.result, el.values);
    });
  }

  sum(...arrays) {
    return arrays
      .sort((a, b) => b.length - a.length)
      .reduce((a, c) => a.map((n, i) => n + (c[i] || 0)) || c);
  }

  selectOption(e) {
    const target = e.targetElement;
    const question = target.closest('[data-question]');
    const option = target.getAttribute('data-option');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const modifier = isMobile ? '.--mobile' : '.--desktop';

    document.querySelectorAll(`[data-linked-option`)?.forEach((option) => {
      if (window.getComputedStyle(option).display != 'none') option._hide(0);
    });
    document.querySelector(`[data-linked-option="${option}"]${modifier}`)?._show(0);

    question.querySelector('.js-continue-quiz').disabled = false;
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.QuizController = new QuizController();
  }
});
